module.exports = __webpack_public_path__ + "static/media/mailchimp_logo.35def528.svg";